export default __webpack_public_path__ + "static/media/TimeManagement.eb5debbd.png";